import { types, flow, getRoot, clone, applySnapshot } from "mobx-state-tree";
import { db } from "../firebase.js";
import { actions } from "./_common.js";
import { values } from "mobx";
import * as H from "../helpers";
import FirebaseStore from "./Firebase";

const $firebase = new FirebaseStore();
const refSurveys = db.collection("surveys");

export const Condition = types
  .model({
    question: types.maybeNull(types.string),
    condition: types.optional(types.string, "is"),
    answer: types.maybeNull(types.string)
  })
  .actions(self => ({
    change(e) {
      self[e.target.name] = e.target.value;
    }
  }));

export const Logic = types
  .model({
    conditions: types.optional(types.map(Condition), {}),
    action: types.maybeNull(types.string)
    //questionKey: types.maybeNull(types.string)
  })
  .actions(self => ({
    change(e) {
      self[e.target.name] = e.target.value;
    },
    setToConditionList(key, value) {
      self.conditions.set(key, {
        ...value
      });
    },
    deleteFromConditionList(key) {
      console.log("delete from condi", key);
      self.conditions.delete(key);
    }
  }));

export const fieldOption = types.compose(
  types
    .model({
      locale: types.frozen({}),
      value: types.maybeNull(types.string),
      label: types.maybeNull(types.string)
    })
    .actions(self => ({
      slugifyAndChange: function (value) {
        self.value = H.slugify(value);
      }
    })),
  actions
);

export const Question = types.compose(
  types
    .model("Question", {
      _key: types.identifier,
      _path: types.maybeNull(types.string),
      _tempSiblingKeysAfter: types.optional(types.array(types.string), []),
      name: types.optional(types.string, ""), //deprecated
      parentKey: types.maybeNull(types.string),
      type: types.optional(types.string, "text"),
      typeOptions: types.optional(types.array(fieldOption), []),
      steps: types.optional(types.string, "2"),
      createdOn: types.optional(types.number, Date.now()),
      logic: types.maybeNull(Logic),
      createdBy: types.maybeNull(types.string),
      createdForGroup: types.maybeNull(types.string),
      required: types.optional(types.boolean, false),
      surveyKey: types.maybeNull(types.string),
      order: types.optional(types.number, 0),
      level: types.optional(types.number, 0),
      description: types.optional(types.string, ""),
      feedback: types.optional(types.string, ""),
      enabled: types.optional(types.boolean, true),
      pageBreak: types.optional(types.boolean, false),
      multipleAnswers: types.optional(types.boolean, false),
      locale: types.frozen({}),
      _showChildren: types.maybeNull(types.boolean),
      _showTips: types.maybeNull(types.boolean)
    })
    .actions(self => ({
      fsSave: flow(function* () {
        const { $alert, $locale, $survey } = getRoot(self);
        let keyNew = self._key === "new";
        $alert.add("loading", {
          loader: "circle"
        });
        const ref = refSurveys.doc(self.surveyKey).collection("questions");
        let questionDoc = !keyNew ? ref.doc(self._key) : ref.doc();
        //prepare question
        let question = Object.assign({}, self.toJSON());
        delete question._key;
        delete question._path;

        self.updateSiblingsOrder();

        //save or update question / also update state since we dont use onsnapshot
        yield !keyNew ? questionDoc.update(question) : questionDoc.set(question);

        //update and save locale
        values($locale.selectedList).forEach(locale => {
          const keyArr = locale.parentKey.split("_");
          if (keyArr.find(key => key === "new")) {
            //ie. "new_option1"
            if (keyArr.length > 1) {
              const index = keyArr.findIndex(key => key === "new");
              keyArr[index] = questionDoc.id;
              locale.change("parentKey", keyArr.join("_"));
            } else {
              locale.change("parentKey", questionDoc.id);
            }
          }
          locale.fsSave();
          //getRoot(self).$locale.
        });

        //save survey (updateby en on)
        $survey.selected.fsSave();
        $alert.delete("loading");
        self._key === "new" &&
          $alert.add("added", {
            label: "Vraag toegevoegd",
            time: 5000
          });

        return questionDoc;
      }),
      fsDelete: flow(function* () {
        let root = getRoot(self);
        root.$alert.add("loading", {
          loader: "circle"
        });
        let questionKey = self._key;
        let surveyKey = self.surveyKey;
        if (self.type === "fieldset") {
          const items = yield refSurveys
            .doc(surveyKey)
            .collection("questions")
            .where("parentKey", "==", questionKey)
            .get();
          items.docs.forEach(doc => doc.ref.delete());
        }

        //remove locale
        const locale = root.$locale.getLocaleByParentKey(questionKey);
        if (locale) {
          locale.fsDelete();
          self.typeOptions.length &&
            self.typeOptions.forEach((option, i) => {
              const locale = getRoot(self).$locale.list.get(self._key + "_option" + i);
              locale && locale.fsDelete();
            });
        }

        //remove question
        yield refSurveys.doc(surveyKey).collection("questions").doc(questionKey).delete();
        root.$alert.delete("loading");
      }),

      initLogic(e) {
        if (e.target.checked) {
          self.logic = {
            action: ""
          };
          self.logic.setToConditionList(Date.now(), {
            question: getRoot(self).$question.selected._key,
            condition: "is",
            answer: ""
          });
        } else {
          self.logic = null;
        }
      },
      addToTypeOptions: function (value) {
        const locale = {};
        locale["nl_BE"] = value;

        self.typeOptions.push({
          value: H.slugify(value),
          locale
        });
      },
      removeFromTypeOptions: function (option, i) {
        if (option) {
          const index = self.typeOptions.findIndex(o => o.value === option.value);
          if (index > -1) {
            self.typeOptions.splice(index, 1);
          }
        }
      },
      disableOtherQuestionFromLogic(answerValue) {
        const { $survey } = getRoot(self);
        const q = self;

        if (q && q.logic) {
          let condition = values(q.logic.conditions)[0];
          let action = q.logic.action.split("_");
          let disabled =
            (condition.question === q._key &&
              condition.condition === "is" &&
              answerValue === condition.answer) ||
            (condition.question === q._key &&
              condition.condition === "not" &&
              answerValue !== condition.answer);

          getRoot(self).$question.list.get(action[1]).change("enabled", !disabled);

          //remove from templist
          if (disabled) {
            const questionToHide = getRoot(self).$question.list.get(action[1]);
            if (questionToHide.type === "fieldset") {
              const children = $survey.selected.questions.filter(q => q.parentKey === action[1]);
              children.forEach(child => {
                if (child.type === "fieldset") {
                  const children = $survey.selected.questions.filter(
                    q => q.parentKey === child._key
                  );
                  children.forEach(child => {
                    getRoot(self).$answer.deleteFromList(
                      child._key,
                      getRoot(self).$answer.tempAnswerValues
                    );
                  });
                } else {
                  getRoot(self).$answer.deleteFromList(
                    child._key,
                    getRoot(self).$answer.tempAnswerValues
                  );
                }
              });
            } else {
              getRoot(self).$answer.deleteFromList(
                action[1],
                getRoot(self).$answer.tempAnswerValues
              );
            }
          }
        }
      },
      handleDragOver: function (fromKey, toKey) {
        const fromQ = getRoot(self).$question.list.get(fromKey);
        const toQ = getRoot(self).$question.list.get(toKey);

        const fromQOrder = fromQ.order;
        const toQOrder = toQ.order;

        //only used for one case
        if (fromQ.createdForGroup && fromQ.type === "fieldset") {
          const creatorSiblings = self.siblings.filter(q => !q.createdForGroup);
          if (
            creatorSiblings.length &&
            creatorSiblings[creatorSiblings.length - 1]._key === toQ._key
          ) {
            fromQ.change("order", toQ.order < fromQ.order ? toQ.order - 1 : toQ.order + 1);
          }
        }

        //default
        if (!fromQ.createdForGroup || (fromQ.createdForGroup && fromQ.type !== "fieldset")) {
          fromQ.change("order", toQOrder);
          toQ.change("order", fromQOrder);
        }
      },
      updateSiblingsOrder: function () {
        const { $question, $survey } = getRoot(self);
        if (self._tempSiblingKeysAfter) {
          self._tempSiblingKeysAfter.forEach((key, i) => {
            let _q = $question.list.get(key);
            _q && _q.change("order", _q.order + 100);
          });
        }
        // const siblings = self.siblings.map((q, i) => {
        //   if ($question.list.has(q._key)) {
        //     let _q = $question.list.get(q._key);
        //     _q.change("order", i);
        //     console.log("-order", _q._key, _q.order);

        //     return _q;
        //   }
        // });
        $firebase.batchUpdateQuestions($survey.selected._key, self.siblings, ["order"]);
      },
      toggleShowChildren: function () {
        self._showChildren = !self._showChildren;
      },
      toggleShowTips: function () {
        self._showTips = !self._showTips;
      }
    }))
    .views(self => ({
      get answerTemp() {
        return getRoot(self).$answer.tempAnswerValues
          ? getRoot(self).$answer.tempAnswerValues.get(self._key)
          : false;
      },
      get draggable() {
        const { $user, $question } = getRoot(self);
        if ($user.sessionUser.isMentor && !$user.sessionUser.isCreator) {
          return $user.sessionUser.groups.indexOf(self.createdForGroup) > -1;
        }
        if ($user.sessionUser.isCreator) {
          return (self.type !== "fieldset" && !$question.openDragDialog) || $question.openDragDialog
            ? true
            : false;
        }
      },
      get translatedTypeOptions() {
        const { $locale } = getRoot(self);
        return self.typeOptions.map((option, i) => ({
          value: option.value,
          label:
            option.locale[$locale.activeLocale] ||
            $locale.t(self._key + "_option" + i) ||
            option.label
        }));
      },
      getResponses(uid = false, groupKey = false) {
        return getRoot(self).$survey.selected.responses.filter(
          r =>
            ((groupKey && r.groupKey === groupKey) || !groupKey) &&
            ((uid && r.createdBy === uid) || !uid)
        );
      },
      getAnswerValuesFor(entity, id) {
        let responses = self.getResponses(entity === "individual" && id, entity === "group" && id);

        if (!self.children.length) {
          //no fieldset
          return [].concat.apply(
            [],
            responses.map(r => r.answers[self._key]).filter(value => value)
          );
        } else {
          //fieldset
          const values = [].concat
            .apply(
              [],
              self.children.map(q => responses.map(r => r.answers[q._key]))
            )
            .filter(value => value);
          return values;
        }
      },
      getAnswerValuesForGroup(groupKey) {
        return self.getAnswerValuesFor("group", groupKey);
      },
      getAnswerValuesForIndividual(uid) {
        return self.getAnswerValuesFor("individual", uid);
      },
      getAverageAnswerValue(filter) {
        if (filter && filter.by === "groupKey" && !filter.value) return false;
        let values =
          (filter && filter.by === "groupKey") || !filter
            ? self.getAnswerValuesForGroup(filter && filter.value)
            : self.getAnswerValuesForIndividual(filter.value);

        let sumValues = values.reduce((a, b) => Number(a) + Number(b), 0);
        return values.length ? sumValues / values.length : values.length;
      },
      get translations() {
        return values(getRoot(self).$locale.list).map(
          translation => translation.parentKey === self._key && translation
        );
      },
      get isEditable() {
        return self.surveyKey === getRoot(self).$survey.selected._key;
      },
      get children() {
        return values(getRoot(self).$question.list).filter(q => q.parentKey === self._key);
      },
      get siblings() {
        const loop = (children, match = []) => {
          children.forEach(q => {
            q.parentKey === self.parentKey && match.push(getRoot(self).$question.list.get(q._key));
            q.children && loop(q.children, match);
          });
          return match;
        };
        return loop(getRoot(self).$survey.selected.questionTree);
      },
      get siblingKeysAfter() {
        let match = false;
        return self.siblings
          .filter(q => {
            if (q._key === self._key) {
              match = true;
            } else {
              return match;
            }
          })
          .map(q => q._key);
      },
      get _level() {
        const tree = getRoot(self).$survey.selected.questionTree;
        return tree && recursive(tree);
        function recursive(tree = [], count = 0) {
          const match = tree.some(question => question._key === self._key);
          if (match) {
            return count;
          } else {
            count++;
            let _match = false;
            tree.forEach(question => {
              if (!_match) {
                _match = recursive(question.children, count);
              }
            });
            return count;
          }
        }
      },
      get index() {
        return 0; //getRoot(self).$survey.selected.questionTree.find(question.)
      },
      get hasSubChildrenFieldsets() {
        return self.children.filter(subChild => subChild.type === "fieldset").length;
      },
      get childrenRecursive() {
        let allChildren = [];
        let level1 = values(getRoot(self).$question.list).filter(q => q.parentKey === self._key);

        allChildren.push(level1);
        level1.forEach(fieldset => {
          let level2 = values(getRoot(self).$question.list).filter(
            q => q.parentKey === fieldset._key
          );
          allChildren.push(level2);
          level2.forEach(fieldset => {
            let level3 = values(getRoot(self).$question.list).filter(
              q => q.parentKey === fieldset._key
            );
            allChildren.push(level3);
          });
        });
        return [].concat.apply([], allChildren).filter(child => child.type !== "fieldset");
      },
      get showChildren() {
        if (self._showChildren == null) {
          return !self.children.some(
            child => child.type === self.children[0].type && child.type.indexOf("scale") > -1
          );
        } else {
          return self._showChildren;
        }
      },
      get showTips() {
        return self._showTips;
      }
    })),
  actions
);

export const QuestionStore = types.compose(
  types
    .model({
      list: types.optional(types.map(Question), {}),
      status: types.optional(types.string, "pending"),
      selected: types.maybeNull(Question),
      duplicateFrom: types.maybeNull(types.string),
      dragFrom: types.maybeNull(types.string),
      dragTo: types.maybeNull(types.string),
      openDragDialog: types.maybeNull(types.string),
      activeQuestion: 0,
      tipsOfQuestionsVisible: types.optional(types.array(types.string), []),
      confirmDeleteQuestion: types.optional(types.string, "")
    })
    .actions(self => ({
      loadForSurvey: flow(function* (surveyKey, key) {
        try {
          if (key) {
            const snapshot = yield FirebaseStore.getSurveyQuestions(surveyKey, key);
            if (snapshot.exists) {
              this.setSelected({
                _key: snapshot.id,
                ...snapshot.data()
              });
            }
          } else {
            getRoot(self).$alert.add("loading");
            $firebase.db
              .collection("surveys")
              .doc(surveyKey)
              .collection("questions")
              .onSnapshot(snapshot => {
                let list = {};
                snapshot.forEach(doc => {
                  list[doc.id] = doc.data();
                  list[doc.id]._key = doc.id;
                });
                applySnapshot(self.list, list);
                self.loadTempAnswers(surveyKey);
                self.setProp("status", "done");
                getRoot(self).$alert.delete("loading");
              });
          }
        } catch (error) {
          console.log("error", error);
        }
      }),

      loadTempAnswers(surveyKey) {
        let tempAnswerValues =
          JSON.parse(localStorage.getItem("barometer-answers-" + surveyKey)) || {};

        if (tempAnswerValues) {
          applySnapshot(getRoot(self).$answer.tempAnswerValues, tempAnswerValues);

          getRoot(self).$answer.tempAnswerValues.forEach((value, questionKey) => {
            self.list.has(questionKey) &&
              self.list
                .get(questionKey)
                .disableOtherQuestionFromLogic(tempAnswerValues[questionKey], questionKey);
          });
        }
      },

      setSelected(question) {
        const { $locale, $user, $survey, $group } = getRoot(self);
        const initQuestion = {
          _key: "new",
          name: "",
          createdBy: $user.sessionUser.uid,
          createdOn: Date.now(),
          surveyKey: $survey.selected._key,
          updatedOn: Date.now(),
          createdForGroup: $survey.selected.questions_for_group
            ? $group.selected && $group.selected._key
            : null
        };

        if (self.duplicateFrom) {
          self.change("selected", {
            ...H.removeInternalPropsAndFuncs(question.toJSON()),
            ...initQuestion,
            order: question.order + 100
          });
          $locale.setLocalesToTempList($locale.getLocalesByParentKey(self.duplicateFrom), true);
          self.change("duplicateFrom", null);
        } else {
          self.selected =
            question._key === "new" ? { ...initQuestion, ...question } : clone(question);
        }
      },
      prevActiveQuestion(e) {
        e.preventDefault();
        self.activeQuestion--;
      },
      nextActiveQuestion(e) {
        e.preventDefault();
        self.activeQuestion++;
      }
    })),
  actions
);
